import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Row } from '@tanstack/react-table';
import { FormattedMessage } from 'react-intl';

import { Button } from 'src/registry/ui/Button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/registry/ui/Tooltip';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import DeleteSubscriptionItemQuantityEventFormModal from 'src/features/subscriptionItemQuantityEvents/components/forms/DeleteSubscriptionItemQuantityEventFormModal';
import { SubscriptionItemQuantityEvent } from 'src/features/subscriptionItemQuantityEvents/utils/types';

type CellSubscriptionItemQuantityEventActionsProps = {
    row: Row<SubscriptionItemQuantityEvent>;
};

export default function CellSubscriptionItemQuantityEventActions({
    row,
}: CellSubscriptionItemQuantityEventActionsProps) {
    return (
        <div className="flex w-full justify-end gap-1">
            <TooltipProvider>
                <Tooltip>
                    <DeleteSubscriptionItemQuantityEventFormModal selectedQuantityEvent={row.original}>
                        <TooltipTrigger asChild>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.DELETE} />
                            </Button>
                        </TooltipTrigger>
                    </DeleteSubscriptionItemQuantityEventFormModal>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.delete} />
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
        </div>
    );
}
